<template>
  <div class="login-wrap">
    <el-form
      class="login-form"
      label-position="top"
      label-width="80px"
      :model="formdata"
      v-loading="loading"
      :rules="rules"
      ref="form"
    >
      <div style="margin-bottom: 5%">
        <h2>Sign In</h2>
        <el-form-item label="Username" prop="username">
          <el-input v-model="formdata.username" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input
            prefix-icon="el-icon-more-outline"
            v-model.trim="formdata.password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" label="Google">
          <el-input
            v-model.trim="formdata.code"
            prefix-icon="el-icon-chat-dot-round"
            placeholder="Nhập mã xác minh Google"
          ></el-input>
        </el-form-item>
        <!--        <img :src="captchaImg" alt="" @click="changeed()" style="margin-left: 45%" />-->
      </div>
      <el-button @click="handleLogin()" class="login-btn" type="primary">登录</el-button>
    </el-form>
  </div>
</template>

<script>
import { checkPass } from '@/utils/validate';
export default {
  data() {
    return {
      loading: false,
      formdata: {
        username: '',
        password: '',
        code: ''
      },
      captchaImg: '' //图片路径
    };
  },

  created() {
    if (process.env.NODE_ENV === 'development') {
      this.formdata.username = 'admin';
      this.formdata.password = '123456';
    }
    // this.Render();
    this.rules = {
      username: [
        {
          required: true,
          message: this.$t('login.rules.username'),
          trigger: 'blur'
        }
      ],
      code: [
        {
          required: true,
          message: this.$t('login.rules.code'),
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: this.$t('login.rules.password'),
          trigger: 'blur'
        },
        {
          validator: (rule, value, cb) => {
            if (!checkPass(value)) {
              cb(new Error(this.$t('passwd.rules.newPasswd.format')));
            } else {
              cb();
            }
          },
          trigger: 'blur'
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
    document.removeEventListener('keyup', (e) => {
      if (e && e.keyCode == 13) {
        this.handleLogin();
      }
    });
  },
  methods: {
    init() {
      document.addEventListener('keyup', (e) => {
        if (e && e.keyCode == 13) {
          this.handleLogin();
        }
      });
    },
    // 获取验证码
    async Render() {
      this.loading = true;
      let res = await this.$http.get('/token/render', {
        responseType: 'blob'
      });
      console.log(res);
      this.loading = false;
      this.captchaImg = window.URL.createObjectURL(res.data);
    },
    // 切换验证码
    changeed() {
      this.Render();
    },
    loginSuccess(res) {
      this.$message.success(res.msg);
      this.$router.push({
        path: '/merchant'
        //  path: res.data.menuTree[0].menuUrl
      });
    },
    async handleLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            kaptchaCode: this.formdata.code,
            password: this.formdata.password,
            userName: this.formdata.username
          };
          const data = await this.$store.dispatch('handleLogin', params);
          if (data.code === 200) {
            this.loginSuccess(data);
          } else {
            // //刷新验证码
            // this.Render();
            this.formdata.code = '';
            this.$message.error(data.msg || 'Network error!');
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.login-wrap {
  height: 100vh;
  background-color: #324152;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-wrap .login-form {
  width: 400px;
  background-color: #fff;
  border-radius: 5px;
  padding: 30px;
}

.login-wrap .login-btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue